import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {unref} from "vue";
import getFieldJson, {normalizeUserDefSelectField} from "@/main-page-extend/containers/userDefField/data/defFieldData";
import {StorageUtils} from "xmgoing-utils";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {qiankunWindow} from "vite-plugin-qiankun/dist/helper";

const _loadUserCols=function (props,fieldList,pageCodeVal,backFun,afterLoadList){
    const queryCommand = new QueryCommand({
        url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/execute/pageByTableCode/TB_CUSTOMFIELD',
        showTip: false,
        method: "POST"
    });
    const params = {domainCode_equal:pageCodeVal||unref(props).menuCode};
    queryCommand.executeQueryPromise({params}).then((res: any) => {
        if(res.records&&Array.isArray(res.records)){
            res.records.forEach((itemDb)=>{
                const itemDbObj:any=getFieldJson(itemDb);
                if(itemDbObj.props){
                    itemDbObj.props.isFormEl=true;
                }else{
                    itemDbObj.props={isFormEl:true}
                }
                if (itemDb.options) {
                    itemDbObj._fieldOptions = itemDb.options;
                }
                normalizeUserDefSelectField(itemDbObj, itemDb);
                unref(fieldList).push(itemDbObj);
            })
            backFun&&backFun(unref(fieldList));
            afterLoadList&&afterLoadList(unref(fieldList));
            StorageUtils.addSessionItem((pageCodeVal||unref(props).pageCode)+unref(props).key+"FieldJson",JSON.stringify(unref(fieldList)));
        }
    });
}

export function useDefFieldHooks({props,events}){
    const fieldList:any=ref([])
    const {clickEvent, viewModel} = useComEvent({events});
    /**
     * 数据加载后事件
     * @param fieldList
     */
    const afterLoadList=function (_fieldList){
        clickEvent('afterLoadList', {_fieldList});
        //如果设置了 为空隐藏分组
        if(unref(props).emptyHideGroup){
            //开发态不隐藏，运行态进行演示
            if(_fieldList.length===0){
                if (qiankunWindow.__POWERED_BY_QIANKUN__||window.appObj.preview) {
                    const elObj=document.getElementById(unref(props).key);
                    if(elObj){
                        if(elObj.closest(".xmFormGroupPanel-col-ctl")){
                            elObj.closest(".xmFormGroupPanel-col-ctl").style.display='none';
                        }
                    }
                }
            }
        }
    }
    /**
     * 加载用户定义的列
     */
    const loadUserCols=function (pageCodeVal?:any,backFun?:any){
        fieldList.value=[];
        let fieldJson=StorageUtils.getSessionItem((pageCodeVal||unref(props).pageCode)+unref(props).key+"FieldJson");
        if (((window as any).appObj&&(window as any).appObj.isDes)||(window.appObj&&window.appObj.isDevMpdal)) {
            fieldJson=null;
        }
        if(fieldJson&&fieldJson.length>0){
            try{
                const fieldJsonList = JSON.parse(fieldJson);
                const hasIncompleteSelect = fieldJsonList.some((itemDb) => {
                    const componentKey = itemDb.componentKey || itemDb.props?.componentKey;
                    return componentKey === 'xmSelect'
                        && !(itemDb.dataConfig?.dataList && Array.isArray(itemDb.dataConfig.dataList) && itemDb.dataConfig.dataList.length > 0);
                });
                if (hasIncompleteSelect) {
                    StorageUtils.removeSessionItem((pageCodeVal||unref(props).pageCode)+unref(props).key+"FieldJson");
                    _loadUserCols(props,fieldList,pageCodeVal,backFun,(fieldList)=>{
                        afterLoadList(fieldList);
                    });
                    return;
                }
                fieldJsonList.forEach((itemDb)=>{
                    if(itemDb.props){
                        itemDb.props.isFormEl=true;
                        itemDb.props.isUserDefEl=true;
                    }else{
                        itemDb.props={isFormEl:true,isUserDefEl:true}
                    }
                    normalizeUserDefSelectField(itemDb);
                })
                fieldList.value=fieldJsonList;
                afterLoadList(unref(fieldList));
                backFun&&backFun(unref(fieldList));
            }catch (e){
                StorageUtils.removeSessionItem((pageCodeVal||unref(props).pageCode)+unref(props).key+"FieldJson");
                _loadUserCols(props,fieldList,pageCodeVal,backFun,(fieldList)=>{
                    afterLoadList(fieldList);
                });
            }
        }else{
            _loadUserCols(props,fieldList,pageCodeVal,backFun,(fieldList)=>{
                afterLoadList(fieldList);
            });
        }
    }

    onMounted(()=>{
        if(unref(props).menuCode){
            loadUserCols();
        }
    })

    return {
        loadUserCols,
        fieldList
    }
}
